import { type SubscriptionInfo, type User } from "lens-platform-sdk";
import { isLensTrialPlan } from "src/services/plans";

export const isTrialUsed = (subscriptions: SubscriptionInfo[]) => {
  return subscriptions.some((subscription) => isLensTrialPlan(subscription.planCode));
};

export const getUserAvatar = (user: User) =>
  user.userAttributes?.find((attribute) => attribute.name === "avatar")?.value;
